import { render, staticRenderFns } from "./searchSimple.vue?vue&type=template&id=4a1ec41a&"
import script from "./searchSimple.vue?vue&type=script&lang=ts&"
export * from "./searchSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a1ec41a', component.options)
    } else {
      api.reload('4a1ec41a', component.options)
    }
    module.hot.accept("./searchSimple.vue?vue&type=template&id=4a1ec41a&", function () {
      api.rerender('4a1ec41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/searchSimple.vue"
export default component.exports